/**
 * @generated SignedSource<<1d6855ec0a749a41169ad18fea189d4c>>
 * @relayHash 82e58e09cb6c0ae8731a0483a5357faf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6

import type { ConcreteRequest } from 'relay-runtime';
export type ReactionsPlaceholderQuery$variables = {
  contentId: string;
};
export type ReactionsPlaceholderQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly contentReactionsSummary: {
        readonly reactionsSummaryForEmoji: ReadonlyArray<{
          readonly id: string;
        } | null>;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
};
export type ReactionsPlaceholderQuery = {
  response: ReactionsPlaceholderQuery$data;
  variables: ReactionsPlaceholderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "concreteType": "ReactionsSummaryResponse",
            "kind": "LinkedField",
            "name": "contentReactionsSummary",
            "plural": false,
            "selections": [
              {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                  (v1/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ReactionsPlaceholderQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReactionsPlaceholderQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "82e58e09cb6c0ae8731a0483a5357faf",
    "id": "d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6",
    "metadata": {},
    "name": "ReactionsPlaceholderQuery",
    "operationKind": "query",
    "text": "query ReactionsPlaceholderQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsSummaryForEmoji{id}}}}}"
  }
};
})();

(node as any).hash = "22ecbec40a97883abeadc26399cf4367";

export default node;
